import { z } from 'zod';

import { isInvalidNonEmptyTotalCupsPerDay, NUMBER_OF_PETS_VALUES } from './form.constants';
import { messages } from './messages';

export const getFormSchema = () =>
    z.object({
        numberOfPets: z
            .string()
            .trim()
            .min(1, messages.numberOfPetsRequired)
            .superRefine((value, ctx) => {
                if (value && !NUMBER_OF_PETS_VALUES.includes(value)) {
                    ctx.addIssue({ code: 'custom', message: messages.numberOfPetsInvalid });
                }
            }),
        totalCupsPerDay: z
            .string()
            .trim()
            .min(1, messages.totalCupsPerDayRequired)
            .superRefine((value, ctx) => {
                if (isInvalidNonEmptyTotalCupsPerDay(value)) {
                    ctx.addIssue({ code: 'custom', message: messages.totalCupsPerDayInvalid });
                }
            }),
    });
